import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/life-general-types/life/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useLazyFetchOpenPostPostings =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useLazyQuery
